export default (style)=>{
  return(`

    .TabBar {
      display: flex;
    }

    .TabBar .Search {
      position: relative;
    }
  `)
}
